import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  Chip,
  Select,
  MenuItem,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
  IconButton,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { useState, useEffect } from "react";
import { post } from "../../../utils/api";
import BulkFileUpload from "./BulkFileUpload";

const FugitiveBulkUpload = ({
  matchData,
  onClose,
  onConfirm,
  bulkUploadTable,
  bulkuploadInputData,
  url,
  title1,
  title2,
  keyValue1,
  keyValue2,
  options1,
  options2,
  matched1,
  matched2,
  setFormDataBulkUpload,
  formDataBulkUpload,
  jsonBulkUpload = [],
  bulkUploadUrl,
  setsnackOpen,
  fieldName,
  }) => {

  const [optionList1, setOptionList1] = useState([]);
  const [optionList2, setOptionList2] = useState([]);
  const [disabled, setDisabled] = useState(false);
  const [uploadValidationErrors, setUploadValidationErrors] = useState([]);
  const [hasValidationBeenAttempted, setHasValidationBeenAttempted] = useState(false);
  
  // Document upload confirmation state
  const [documentUploadConfirmed, setDocumentUploadConfirmed] = useState(false);
  // Document upload type state
  const [documentUploadType, setDocumentUploadType] = useState("none"); // "none", "individual", "same"
  const [commonDocument, setCommonDocument] = useState(null);
  const [individualDocuments, setIndividualDocuments] = useState({});
  // State to show confirmation dialog for proceeding without documents
  const [showNoDocumentDialog, setShowNoDocumentDialog] = useState(false);
  console.log(matchData, "matchData");
  
  // Monitor jsonBulkUpload changes
  useEffect(() => {
    if (jsonBulkUpload && jsonBulkUpload.length > 0) {
      setFormDataBulkUpload(jsonBulkUpload);
    }
  }, [jsonBulkUpload]);

  useEffect(() => {
    if (options1) {
      setOptionList1(options1);
    }
    if (options2) {
      setOptionList2(options2);
    }
  }, [options1, options2]);

  useEffect(() => {
    const disable = Object.values(formDataBulkUpload)?.some(item =>
      (title2 && !options2?.includes(item?.[title2])) ||
      (title1 && !options1?.includes(item?.[title1]))
    );
    setDisabled(disable);
  }, [formDataBulkUpload, title1, title2, options1, options2]);

  // Document upload handler functions
  const handleDocumentUploadConfirmation = (confirmed) => {
    setDocumentUploadConfirmed(confirmed);
    
    if (!confirmed) {
      // Reset document upload type to "none" if user chooses not to upload
      setDocumentUploadType("none");
    }

    // Clear validation errors when document upload confirmation changes
    setUploadValidationErrors([]);
    setHasValidationBeenAttempted(false);
  };

  const handleDocumentUploadTypeChange = (event) => {
    setDocumentUploadType(event.target.value);
    
    setCommonDocument(null);
    setIndividualDocuments({});

    // Clear validation errors when document upload type is selected
    setUploadValidationErrors([]);
    setHasValidationBeenAttempted(false);
  };

  const handleCommonDocumentChange = (files) => {
    setCommonDocument(files);
    
    // Convert files to array if it's not already an array
    const filesArray = Array.isArray(files) ? files : Object.values(files);
    
    // Update finalJson with common document for all entries
    const formDataArray = Array.isArray(formDataBulkUpload) ? formDataBulkUpload : Object.values(formDataBulkUpload);
    
    if (formDataArray && formDataArray.length > 0) {
      const updated = formDataArray.map((entry) => ({
        ...entry,
        "Document (optional)": filesArray,
      }));
      setFormDataBulkUpload(updated);
    }

    // Clear validation errors when documents are uploaded
    if (filesArray && filesArray.length > 0) {
      setUploadValidationErrors([]);
      setHasValidationBeenAttempted(false);
    }
  };

  const handleIndividualDocumentChange = (index, files) => {
    // Convert files to array if it's not already an array
    const filesArray = Array.isArray(files) ? files : Object.values(files);
    
    setIndividualDocuments((prev) => ({
      ...prev,
      [index]: filesArray,
    }));
    
    // Update finalJson with individual document for specific entry
    const formDataArray = Array.isArray(formDataBulkUpload) ? formDataBulkUpload : Object.values(formDataBulkUpload);
    
    if (formDataArray && formDataArray.length > 0) {
      const updated = formDataArray.map((entry, i) => {
        if (i === index) {
          return {
            ...entry,
            "Document (optional)": filesArray,
          };
        }
        return entry;
      });
      setFormDataBulkUpload(updated);
    }

    // Clear validation errors when documents are uploaded
    if (filesArray && filesArray.length > 0) {
      setUploadValidationErrors([]);
      setHasValidationBeenAttempted(false);
    }
  };

  const handleClearCommonDocument = () => {
    setCommonDocument(null);
    
    // Update finalJson to clear common document for all entries
    const formDataArray = Array.isArray(formDataBulkUpload) ? formDataBulkUpload : Object.values(formDataBulkUpload);
    
    if (formDataArray && formDataArray.length > 0) {
      const updated = formDataArray.map((entry) => ({
        ...entry,
        "Document (optional)": null,
      }));
      setFormDataBulkUpload(updated);
    }
  };

  const handleClearIndividualDocument = (index) => {
    setIndividualDocuments((prev) => {
      const newDocs = { ...prev };
      delete newDocs[index];
      return newDocs;
    });
    
    // Update finalJson to clear individual document for specific entry
    const formDataArray = Array.isArray(formDataBulkUpload) ? formDataBulkUpload : Object.values(formDataBulkUpload);
    
    if (formDataArray && formDataArray.length > 0) {
      const updated = formDataArray.map((entry, i) => {
        if (i === index) {
          return {
            ...entry,
            "Document (optional)": null,
          };
        }
        return entry;
      });
      setFormDataBulkUpload(updated);
    }
  };

  const handleProceedWithoutDocuments = () => {
    setShowNoDocumentDialog(false);
    performUpload();
  };

  const handleCancelProceedWithoutDocuments = () => {
    setShowNoDocumentDialog(false);
  };

  if (!matchData || matchData.length === 0) {
    return null;
  }

  console.log(matchData, "matchData");
  const handleFormChange = (index, field, value) => {
    setFormDataBulkUpload((prev) => ({
      ...prev,
      [index]: {
        ...prev[index],
        [field]: value,
      },
    }));
    console.log(formDataBulkUpload, "formDataBulkUpload");
  };

  const validateUploadData = () => {
    const validationErrors = [];

    // Check if user wants to upload documents but hasn't uploaded any
    if (documentUploadConfirmed && documentUploadType === "none") {
      validationErrors.push("Please select a document upload type when document upload is confirmed.");
    }

    return validationErrors;
  };

  const performUpload = async () => {
    // Use jsonBulkUpload as fallback if finalJson is empty
    const dataToUse = formDataBulkUpload && formDataBulkUpload.length > 0 ? formDataBulkUpload : jsonBulkUpload;

    // Convert dataToUse object into array
    const dataToUseArray = Array.isArray(dataToUse) ? dataToUse : Object.values(dataToUse);
    
    // Prepare data structure for upload
    const uploadData = {
      excelData: dataToUseArray,
    };

    console.log("Final upload data structure:", uploadData);

    await post(bulkUploadUrl, uploadData)
      .then((res) => {
        // Clear validation errors and reset validation attempted flag on successful upload
        setUploadValidationErrors([]);
        setHasValidationBeenAttempted(false);
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        onConfirm();
        onClose();
      })
      .catch((err) => {
        const errMessage = err.response?.data?.details
          ?.map((el) => el?.error)
          ?.join(",");
        if (err?.response?.status === 422) {
        }
        setsnackOpen({
          open: true,
          message: errMessage ?? err.response?.data?.message ?? "Network Error",
          severity: "error",
        });
      });
  };

  const handleSubmit = async () => {
    // Mark that validation has been attempted
    setHasValidationBeenAttempted(true);

    const validationErrors = validateUploadData();
    console.log(validationErrors, "validationErrors");

    if (validationErrors.length > 0) {
      setUploadValidationErrors(validationErrors);
      return;
    }

    // Check if user wants to upload documents but hasn't uploaded any
    const needsDocs = documentUploadConfirmed && documentUploadType !== "none";

    if (needsDocs) {
      const hasCommonDoc = documentUploadType === "same" && commonDocument && commonDocument.length > 0;
      const hasIndividualDocs = documentUploadType === "individual" && 
        Object.keys(individualDocuments).length > 0 &&
        Object.values(individualDocuments).some((docs) => docs && docs.length > 0);

      if (!hasCommonDoc && !hasIndividualDocs) {
        setShowNoDocumentDialog(true);
        return;
      }
    }

    // If no dialog is needed, proceed with upload
    await performUpload();
  };
  
return (
  <>
    <Dialog
      open={bulkUploadTable}
      onClose={onClose}
      maxWidth="lg"
      sx={{
        "& .MuiDialog-paper": {
          width: "70%",
          margin: "16px",
          maxHeight: "calc(100% - 32px)",
          zIndex: 1000,
        },
      }}
    >
      <DialogTitle>Review Bulk Upload Data</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Review the matched and unmatched equipment data. Add unmatched items
          individually.
        </Typography>

        <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
          <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold", width: "20%" }}>
                    Data Entered
                  </TableCell>
                  {title2 && (
                    <TableCell sx={{ fontWeight: "bold", width: "20%" }}>
                    </TableCell>
                  )}
                  <TableCell sx={{ fontWeight: "bold", width: "15%" }}>
                    Master Data
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableHead>
              <TableRow>
                <TableCell
                  sx={{ fontWeight: "bold", width: title2 ? "15%" : "40%" }}
                >
                  {title1 ? title1 : "Equipment Name"}
                </TableCell>
                {title2 && (
                  <TableCell sx={{ fontWeight: "bold", width: title2 ? "15%" : "40%" }}>
                    {title2 ? title2 : "Equipment Name"}
                  </TableCell>
                )}
                 <TableCell
                  sx={{ fontWeight: "bold", width: title2 ? "20%" : "40%" }}
                >
                  {title1 ? title1 : "Equipment Name"}
                </TableCell>
                {title2 && (
                  <TableCell sx={{ fontWeight: "bold", width: "20%" }}>
                    {title2 ? title2 : "Equipment Name"}
                  </TableCell>
                )}
                {documentUploadConfirmed && documentUploadType === "individual" && (
                  <TableCell sx={{ fontWeight: "bold", width: "15%" }}>
                    Document
                  </TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {matchData.map((item, index) => (
                <>
                  <TableRow key={index}>
                    <TableCell>
                      {keyValue1 ? item?.[keyValue1] : item.equipment}
                    </TableCell>
                   
                    {title2 && (
                      <TableCell>
                        {keyValue2 ? item?.[keyValue2] : item.equipment}
                      </TableCell>
                    )}
                     <TableCell>
                      {item[matched1] ? (
                        <Chip label="Matched" color="success" size="small" />
                      ) : (
                        <FormControl
                          size="small"
                          sx={{
                            minWidth: title2 ? "10.5rem" : "20rem",
                            maxWidth: title2 ? "10.5rem" : "20rem",
                          }}
                        >
                          <Select
                            value={formDataBulkUpload[index]?.[title1] || ""}
                            onChange={(e) =>
                              handleFormChange(index, title1, e.target.value)
                            }
                            fullWidth
                            displayEmpty
                            disabled={item[matched1]}
                            sx={{
                              minWidth: title2 ? "10.5rem" : "20rem",
                              maxWidth: title2 ? "10.5rem" : "20rem",
                            }}
                            MenuProps={{
                              PaperProps: {
                                style: {
                                  width: title2 ? "10.5rem" : "20rem",
                                },
                              },
                            }}
                          >
                            <MenuItem value="">Tap to Select</MenuItem>
                            {optionList1 &&
                              optionList1.map((item, index) => {
                                return <MenuItem value={item}>{item}</MenuItem>;
                              })}
                          </Select>
                        </FormControl>
                      )}
                    </TableCell>
                    {title2 && (
                      <TableCell>
                        {item[matched2] ? (
                          <Chip label="Matched" color="success" size="small" />
                        ) : (
                          <FormControl
                            size="small"
                            sx={{ minWidth: "10.5rem", maxWidth: "10.5rem" }}
                          >
                            <Select
                              value={formDataBulkUpload[index]?.[keyValue2] || ""}
                              onChange={(e) =>
                                handleFormChange(
                                  index,
                                  title2,
                                  e.target.value
                                )
                              }
                              fullWidth
                              displayEmpty
                              disabled={item[matched2]}
                              sx={{ minWidth: "10.5rem", maxWidth: "10.5rem" }}
                              MenuProps={{
                                PaperProps: {
                                  style: {
                                    width: "10.5rem",
                                  },
                                },
                              }}
                            >
                              <MenuItem value="">Tap to Select</MenuItem>
                              {optionList2 &&
                                optionList2.map((item, index) => {
                                  return (
                                    <MenuItem value={item}>{item}</MenuItem>
                                  );
                                })}
                            </Select>
                          </FormControl>
                        )}
                      </TableCell>
                    )}
                    {documentUploadConfirmed && documentUploadType === "individual" && (
                      <TableCell>
                        <BulkFileUpload
                          filesList={individualDocuments[index] || []}
                          handleChange={handleIndividualDocumentChange}
                          handleClear={handleClearIndividualDocument}
                          index={index}
                        />
                      </TableCell>
                    )}
                  </TableRow>
                  {/* Expandable form row */}
                </>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Document Upload Section */}
        <Box
          sx={{ mt: 3, p: 2, border: "1px solid #e0e0e0", borderRadius: 1 }}
        >
          <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
            Document Upload
          </Typography>
          <Box>
            <FormControl component="fieldset">
              <FormLabel component="legend">
                Do you want to upload document?
              </FormLabel>
              <RadioGroup
                value={documentUploadConfirmed ? "yes" : "no"}
                onChange={(e) =>
                  handleDocumentUploadConfirmation(e.target.value === "yes")
                }
                row
              >
                <FormControlLabel
                  value="yes"
                  control={<Radio />}
                  label="Yes"
                />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
          </Box>
          {documentUploadConfirmed && (
            <FormControl component="fieldset" sx={{ mb: 2, mt: 2 }}>
              <FormLabel component="legend">Document Upload Type</FormLabel>
              <RadioGroup
                value={documentUploadType}
                onChange={handleDocumentUploadTypeChange}
                row
              >
                <FormControlLabel
                  value="same"
                  control={<Radio />}
                  label="Same File for All Records"
                />
                <FormControlLabel
                  value="individual"
                  control={<Radio />}
                  label="Individual File for Each Record"
                />
              </RadioGroup>
            </FormControl>
          )}

          {documentUploadConfirmed && documentUploadType === "same" && (
            <Box sx={{ mb: 2 }}>
              <Typography variant="body2" sx={{ mb: 1 }}>
                Upload a single document that will be associated with all
                records:
              </Typography>
              <BulkFileUpload
                filesList={commonDocument}
                handleChange={handleCommonDocumentChange}
                handleClear={handleClearCommonDocument}
              />
            </Box>
          )}

          {documentUploadConfirmed && documentUploadType === "individual" && (
            <Box sx={{ mb: 2 }}>
              <Typography variant="body2" sx={{ mb: 1 }}>
                Upload individual documents for each record. Documents will
                be added as a new column in the table above.
              </Typography>
            </Box>
          )}
        </Box>

        {/* Validation Error Display - Only show after validation has been attempted */}
        {hasValidationBeenAttempted && uploadValidationErrors.length > 0 && (
          <Box
            sx={{
              mt: 2,
              p: 2,
              backgroundColor: "#ffebee",
              borderRadius: 1,
              border: "1px solid #f44336",
            }}
          >
            <Typography
              variant="h6"
              color="error"
              sx={{ mb: 1, fontWeight: "bold" }}
            >
              Error:
            </Typography>
            {uploadValidationErrors.map((error, index) => (
              <Typography
                key={index}
                variant="body2"
                color="error"
                sx={{ mb: 0.5 }}
              >
                • {error}
              </Typography>
            ))}
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ padding: "1rem" }}>
        <Button
          onClick={onClose}
          variant="outlined"
          color="primary"
          sx={{ marginRight: "1rem" }}
        >
          Cancel
        </Button>
        <Button onClick={handleSubmit} variant="contained" color="primary" disabled={disabled}>
          Confirm Upload
        </Button>
      </DialogActions>
    </Dialog>

    {/* Confirmation Dialog for Proceeding Without Documents */}
    <Dialog
      open={showNoDocumentDialog}
      onClose={handleCancelProceedWithoutDocuments}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography variant="h6">No Documents Uploaded</Typography>
          <IconButton
            onClick={handleCancelProceedWithoutDocuments}
            size="small"
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          You have selected to upload documents but haven't uploaded any files.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Do you want to proceed without uploading documents?
        </Typography>
        <Typography variant="body2" color="text.secondary">
          You can still upload documents later if needed.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ padding: "1rem" }}>
        <Button
          onClick={handleCancelProceedWithoutDocuments}
          variant="outlined"
          color="primary"
          sx={{ marginRight: "1rem" }}
        >
          Upload Documents
        </Button>
        <Button
          onClick={handleProceedWithoutDocuments}
          variant="contained"
          color="primary"
        >
          Proceed Without Documents
        </Button>
      </DialogActions>
    </Dialog>
  </>
  );
};

export default FugitiveBulkUpload;
